import ProceduresPage from './ProceduresPage';

export default ProceduresPage;
